import { useState, Link, motion, axios, Button, Input, Card, CardContent, Label, Textarea, Loader2, Send, LOGO_URL, API, toast } from "@/pages/shared";

export const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !subject || !message) {
      toast.error("Please fill all fields");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, { name, email, subject, message });
      toast.success("Message sent! We'll get back to you soon.");
      setName(""); setEmail(""); setSubject(""); setMessage("");
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
    }
    setSending(false);
  };

  return (
    <div className="min-h-screen bg-background">
      <nav className="fixed top-0 w-full z-50 glass">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Creatara - Contact Support for Content Monetization Help" className="w-10 h-10 rounded-lg" />
            <span className="text-xl font-bold">Creatara</span>
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/help" className="text-muted-foreground hover:text-foreground">Help</Link>
            <Link to="/"><Button variant="ghost">Home</Button></Link>
          </div>
        </div>
      </nav>

      <div className="pt-24 pb-12 px-6">
        <div className="max-w-2xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="text-4xl font-bold mb-4 text-center">Contact Us</h1>
            <p className="text-muted-foreground text-center mb-8">Have questions? We'd love to hear from you.</p>
            
            <Card className="glass">
              <CardContent className="p-6">
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Label>Name</Label>
                      <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" className="mt-1 bg-white/5 border-white/10" required />
                    </div>
                    <div>
                      <Label>Email</Label>
                      <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="mt-1 bg-white/5 border-white/10" required />
                    </div>
                  </div>
                  <div>
                    <Label>Subject</Label>
                    <Input value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="How can we help?" className="mt-1 bg-white/5 border-white/10" required />
                  </div>
                  <div>
                    <Label>Message</Label>
                    <Textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Tell us more..." className="mt-1 bg-white/5 border-white/10 h-32" required />
                  </div>
                  <Button type="submit" className="w-full btn-primary-glow bg-violet-600 hover:bg-violet-700 rounded-full" disabled={sending}>
                    {sending ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Send className="w-4 h-4 mr-2" />}
                    Send Message
                  </Button>
                </form>
              </CardContent>
            </Card>

            <div className="mt-8 text-center text-muted-foreground">
              <p>Or email us directly at: <a href="mailto:support@creatara.ai" className="text-violet-500 hover:underline">support@creatara.ai</a></p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};
